export default {
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    userEmployeeRecord () {
      return this.$store.getters.getUserEmployeeRecord
    },
    userIsAdmin () {
      if (!this.user || !this.user.customMeta) return false
      const role = this.user.customMeta.fields.Role
      return role === 'Admin'
    },
    userHasClearances () {
      if (!this.user || !this.user.customMeta) return false
      return this.user.customMeta.fields.Clearances
    }
  }
}
